var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F5F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_1823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9195 23.9426L22.8521 21.6421V16.9558C22.8521 16.4846 22.4712 16.1038 22 16.1038C21.5288 16.1038 21.1479 16.4846 21.1479 16.9558V22.0682C21.1479 22.3365 21.2741 22.5896 21.4888 22.7498L24.897 25.306C25.0503 25.421 25.2293 25.4764 25.4074 25.4764C25.6672 25.4764 25.9229 25.3597 26.0899 25.1347C26.3728 24.7589 26.2961 24.2247 25.9195 23.9426Z",
    fill: "#4B1498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11C15.9342 11 11 15.9342 11 22C11 28.0658 15.9342 33 22 33C28.0658 33 33 28.0658 33 22C33 15.9342 28.0658 11 22 11ZM22 31.2959C16.8749 31.2959 12.7041 27.1251 12.7041 22C12.7041 16.8749 16.8749 12.7041 22 12.7041C27.126 12.7041 31.2959 16.8749 31.2959 22C31.2959 27.1251 27.1251 31.2959 22 31.2959Z",
    fill: "#4B1498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground3);
export default __webpack_public_path__ + "static/media/Background-3.fea66da0b4eb0649c6e1abd53a0d11d7.svg";
export { ForwardRef as ReactComponent };